import qs from "qs";
import authAxios, { authHeader } from "../data";

const initialize = async (req: { batchId: string; contractId: string }) => {
  const result = await authAxios.get("/api/BatchPayments/Initialize", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return result.data;
};

const fetchAll = async (req: {
  batchId: string;
  pageSize: number;
  pageNumber: number;
  status?: number;
  orderBy?: number;
}) => {
  const result = await authAxios.get("/api/BatchPayments", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return result.data;
};

const fetchCount = async (req: { batchId: string; status?: number }) => {
  const result = await authAxios.get("/api/BatchPayments/Count", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return result.data;
};

const fetch = async (id: string) => {
  const result = await authAxios.get("/api/BatchPayments/" + id, {
    headers: authHeader(),
  });

  return result.data;
};

const remove = async (id: string) => {
  const result = await authAxios.delete("/api/BatchPayments/" + id, {
    headers: authHeader(),
  });

  return result.data;
};

const calculate = async (req: any) => {
  const result = await authAxios.put("/api/BatchPayments/Calculate", req, {
    headers: authHeader(),
  });

  return result.data;
};

const saveAsDraft = async (req: any) => {
  const result = await authAxios.post("/api/BatchPayments", req, {
    headers: authHeader(),
  });

  return result.data;
};

const update = async (id: string, req: any) => {
  const result = await authAxios.put(`/api/BatchPayments/${id}/`, req, {
    headers: authHeader(),
  });

  return result.data;
};

const toggle = async (id: string, isPost: boolean) => {
  const result = await authAxios.put(
    `/api/BatchPayments/${id}/${isPost ? "" : "un"}post`,
    {},
    {
      headers: authHeader(),
    }
  );

  return result.data;
};

const BatchPaymentsService = {
  initialize,
  fetchAll,
  fetchCount,
  fetch,
  remove,
  calculate,
  saveAsDraft,
  toggle,
  update,
};

export default BatchPaymentsService;
